import type { QueryClient } from '@tanstack/react-query'

/**
 * Every screen that shows an order or its job. A lifecycle action (edit,
 * move, re-plan, cancel, payment, refund) can change what any of them says,
 * so all of them are refreshed by prefix.
 */
export function invalidateOrderViews(queryClient: QueryClient) {
  for (const key of ['order-detail', 'orders-page', 'admin-jobs', 'job-sheet', 'section-load', 'admin-dash', 'staff-job', 'partner-job', 'pending-count']) {
    queryClient.invalidateQueries({ queryKey: [key] })
  }
}
